<template>
<div :style="{width,height}" class="layout-wrapper">
  <layout-header :profile="profile" />
  <section class="layout-body">
    <router-view />
  </section>
</div>
</template>

<script>
import LayoutHeader from './Header'
import {mapState} from 'vuex'

export default {
  name: 'Layout',
  components: {
    LayoutHeader
  },
  data () {
    return {
      width: '100vw',
      height: '100vh'
    }
  },
  computed: {
    ...mapState({
      profile: 'Profile'
    })
  },
  methods: {
    onWindowResize () {
      if (/^https?:$/.test(location.protocol)) {
        this.width = '100vw'
        this.height = '100vh'
      } else {
        this.width = `${screen.width}px`
        this.height = `${screen.height}px`
      }
    }
  },
  created () {
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize, true)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize, true)
  }
}
</script>

<style lang="scss" scoped>
$HEADER-HEIGHT: 40px;

.layout-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding-top: $HEADER-HEIGHT;

  .layout-body {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue